<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingSalesDataCreateData"
  >
    <form
      autocomplete="off"
      class="margin-top-large"
      @submit.prevent="createPuntoVenta"
    >
      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-info"></i>
          </span>
          1. Información General
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-4">
              <AtomLogoEditionBilling
                entity="punto_venta"
                :button-secondary="buttonSecondary"
                clase="billing"
                :logo-img="datos.punto_venta.imagen"
                @changeLogoImage="changeLogoImage"
                @deleteLogoImage="deleteLogoImage"
              />
            </div>
            <div class="column column-6">
              <AtomInputPrimary
                v-model="datos.punto_venta.nombre"
                :input-error="$v.datos.punto_venta.nombre.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.nombre.label')"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.nombre.message')"
                :message-error="messageErrorNombre"
                name="nombre"
                reference="nombre"
                :placeholder="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.nombre.placeholder')"
                type="text"
                @blur="$v.datos.punto_venta.nombre.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-map-marker-alt"></i>
          </span>
          2. Información de Ubicación
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-3">
              <AtomSelectPrimaryTimeout
                v-model.number="datos.persona.pais"
                :elements="paises"
                :input-error="$v.datos.persona.pais.$error"
                key-field="id_pais"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.pais.label')"
                :message-error="messageErrorPais"
                name="pais"
                reference="pais"
                text-field="nombre"
                @blur="$v.datos.persona.pais.$touch()"
                @input="readComprobanteTipos(); readParametroDocumentoTipos(); readParametroProvincias()"
              />
            </div>

            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="datos.persona.provincia"
                :elements="provincias"
                :input-error="$v.datos.persona.provincia.$error"
                key-field="id_provincia"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.provincia.label')"
                :message="!datos.persona.pais ? $t('mEditionBillingSalesDataCreateData.inputs.persona.provincia.message') : ''"
                :message-error="messageErrorProvincia"
                name="provincia"
                reference="provincia"
                text-field="nombre"
                @blur="$v.datos.persona.provincia.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="datos.persona.localidad"
                :input-error="$v.datos.persona.localidad.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.localidad.label')"
                :message-error="messageErrorLocalidad"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.persona.localidad.message')"
                name="localidad"
                reference="localidad"
                type="text"
                @blur="$v.datos.persona.localidad.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-2">
              <AtomInputPrimary
                v-model="datos.persona.codigo_postal"
                :input-error="$v.datos.persona.codigo_postal.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.codigo_postal.label')"
                :message-error="messageErrorCodigoPostal"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.persona.codigo_postal.message')"
                name="codigo_postal"
                reference="codigo_postal"
                type="text"
                @blur="$v.datos.persona.codigo_postal.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="datos.persona.linea1"
                :input-error="$v.datos.persona.linea1.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.linea1.label')"
                :message-error="messageErrorLinea1"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.persona.linea1.message')"
                name="linea1"
                reference="linea1"
                type="text"
                @blur="$v.datos.persona.linea1.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="datos.persona.linea2"
                :input-error="$v.datos.persona.linea2.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.linea2.label')"
                :message-error="messageErrorLinea2"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.persona.linea2.message')"
                name="linea2"
                reference="linea2"
                type="text"
                @blur="$v.datos.persona.linea2.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-file-invoice"></i>
          </span>
          3. Información de Comprobante
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="datos.punto_venta.comprobante_tipo"
                :elements="comprobanteTipos"
                :input-error="$v.datos.punto_venta.comprobante_tipo.$error"
                key-field="id_comprobante_tipo"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.comprobante_tipo.label')"
                :message="!datos.persona.pais ? $t('mEditionBillingSalesDataCreateData.inputs.punto_venta.comprobante_tipo.message') : ''"
                :message-error="messageErrorComprobanteTipo"
                name="comprobante_tipo"
                reference="comprobante_tipo"
                text-field="nombre"
                @blur="$v.datos.punto_venta.comprobante_tipo.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="datos.punto_venta.numero"
                :input-error="$v.datos.punto_venta.numero.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.numero.label')"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.numero.message')"
                :message-error="messageErrorNumero"
                name="numero"
                reference="numero"
                :tooltip="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.numero.tooltip')"
                type="text"
                @blur="$v.datos.punto_venta.numero.$touch()"
              />
            </div>

            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="datos.punto_venta.divisa"
                :elements="divisas"
                :input-error="$v.datos.punto_venta.divisa.$error"
                key-field="iso_code"
                :label="datos.punto_venta.comprobante_tipo && datos.punto_venta.comprobante_tipo !== 1 ? $t('mEditionBillingSalesDataEditData.inputs.punto_venta.divisa_emite.label') : $t('mEditionBillingSalesDataEditData.inputs.punto_venta.divisa.label')"
                :message-error="messageErrorDivisa"
                :disabled="isDivisaDisabled"
                name="divisa"
                reference="divisa"
                text-field="nombre"
                :tooltip="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.divisa.tooltip')"
                @blur="$v.datos.punto_venta.divisa.$touch()"
              />
            </div>
          </div>

          <div
            v-if="datos.punto_venta.comprobante_tipo !== 1 && datos.punto_venta.divisa === 'EUR'"
            class="row"
          >
            <div class="column column-10">
              <p class="a-input-wrapper-column margin-bottom-medium">
                <label>
                  {{ $t('mEditionBillingSalesDataCreateData.inputs.punto_venta.divisa_vende.label') }}
                </label>
                <span class="display-flex-row">
                  <span
                    v-for="divisa in divisas"
                    :key="divisa.id"
                  >
                    <AtomCheckboxPrimary
                      v-model="datos.punto_venta.divisa_vende"
                      :disabled="buttonPrimary.sending"
                      inputStyle="billing"
                      :name="`mediodepago-${divisa.id}[]`"
                      :text="divisa.nombre"
                      :value="divisa.iso_code"
                      wrapperClass="margin-right-medium margin-top-small"
                    />
                  </span>
                </span>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="column column-10">
              <AtomTextAreaPrimary
                v-model="datos.punto_venta.mensaje_pie"
                :input-error="$v.datos.punto_venta.mensaje_pie.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.mensaje_pie.label')"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.punto_venta.mensaje_pie.message')"
                :message-error="messageErrorMensajePie"
                name="mensaje_pie"
                reference="mensaje_pie"
                type="text"
                @blur="$v.datos.punto_venta.mensaje_pie.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-balance-scale"></i>
          </span>
          4. Información Legal
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-4">
              <AtomSelectPrimary
                v-model.number="datos.persona.fisica"
                :input-error="$v.datos.persona.fisica.$error"
                :elements="personas"
                key-field="id"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.fisica.label')"
                :message-error="messageErrorFisica"
                name="fisica"
                reference="fisica"
                text-field="nombre"
                @blur="$v.datos.persona.fisica.$touch()"
              />
            </div>

            <div class="column column-6">
              <AtomInputPrimary
                v-model="datos.persona.razon_social"
                :input-error="$v.datos.persona.razon_social.$error"
                :label="datos.persona.fisica === 0
                  ? $t('mEditionBillingSalesDataCreateData.inputs.persona.razon_social.labelBusiness')
                  : $t('mEditionBillingSalesDataCreateData.inputs.persona.razon_social.labelName')"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.persona.razon_social.message')"
                :message-error="messageErrorRazonSocial"
                name="razon_social"
                reference="razon_social"
                type="text"
                @blur="$v.datos.persona.razon_social.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-4">
              <AtomSelectPrimary
                v-model.number="datos.persona.documento_tipo"
                :elements="documentoTipos"
                :input-error="$v.datos.persona.documento_tipo.$error"
                key-field="id_documento_tipo"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.documento_tipo.label')"
                :message="!datos.persona.pais ? $t('mEditionBillingSalesDataCreateData.inputs.persona.documento_tipo.message') : ''"
                :message-error="messageErrorDocumentoTipo"
                name="documento_tipo"
                reference="documento_tipo"
                text-field="nombre"
                @blur="$v.datos.persona.documento_tipo.$touch()"
              />
            </div>

            <div class="column column-6">
              <AtomInputPrimary
                v-model="datos.persona.documento_numero"
                :input-error="$v.datos.persona.documento_numero.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.documento_numero.label')"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.persona.documento_numero.message')"
                :message-error="messageErrorDocumentoNumero"
                name="documento_numero"
                reference="documento_numero"
                type="text"
                @blur="$v.datos.persona.documento_numero.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-billing">
          <span class="legend-icon">
            <i class="fas fa-mobile-alt"></i>
          </span>
          5. Información de Contacto
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-5">
              <AtomInputPrimary
                v-model="datos.persona.telefono"
                :input-error="$v.datos.persona.telefono.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.telefono.label')"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.persona.telefono.message')"
                :message-error="messageErrorTelefono"
                name="telefono"
                reference="telefono"
                type="text"
                @blur="$v.datos.persona.telefono.$touch()"
              />
            </div>

            <div class="column column-5">
              <AtomInputPrimary
                v-model="datos.persona.movil"
                :input-error="$v.datos.persona.movil.$error"
                :label="$t('mEditionBillingSalesDataCreateData.inputs.persona.movil.label')"
                :message="$t('mEditionBillingSalesDataCreateData.inputs.persona.movil.message')"
                :message-error="messageErrorMovil"
                name="movil"
                reference="movil"
                type="text"
                @blur="$v.datos.persona.movil.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div class="m-form-action">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
        <AtomButtonSecondary
          v-if="false"
          :button-secondary="buttonSecondary.reset"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import config from "../../config";

export default {
  name: 'MoleculeEditionBillingSalesDataCreateData',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingSalesDataCreateData.buttonPrimary'),
        class: 'margin-right-medium margin-top-large',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        delete: {
          class: 'a-button-billing-secondary margin-top-xsmall text-color-danger',
          component: '',
          icon: 'far fa-trash-alt text-color-danger',
          method: '',
          text: this.$t('mEditionBillingSalesDataEditData.buttonSecondary.delete'),
          type: 'button'
        },

        modify: {
          class: 'a-button-billing-secondary text-color-billing-primary',
          component: '',
          icon: 'fas fa-image',
          method: '',
          text: this.$t('mEditionBillingSalesDataEditData.buttonSecondary.modify'),
          type: 'button'
        },

        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: '',
          method: '',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'reset'
        },

        upload: {
          class: 'a-button-billing-secondary text-color-billing-primary',
          component: '',
          icon: 'fas fa-image',
          method: '',
          text: this.$t('mEditionBillingSalesDataEditData.buttonSecondary.upload'),
          type: 'button'
        }
      },

      comprobanteTipos: [],

      datos: {
        academia: '',

        persona: {
          codigo_postal: '',
          documento_numero: '',
          documento_tipo: '',
          fisica: 1,
          linea1: '',
          linea2: '',
          localidad: '',
          movil: '',
          pais: '',
          provincia: '',
          razon_social: '',
          telefono: ''
        },

        punto_venta: {
          comprobante_tipo: '',
          divisa: '',
          divisa_vende: [],
          imagen: '',
          mensaje_pie: '',
          nombre: '',
          numero: ''
        }
      },

      divisas: [],
      documentoTipos: [],

      isDivisaDisabled: false,

      monedaDefecto: [
        {
          pais: 30,
          comprobante_tipo: 2,
          divisa: 'EUR'
        },
        {
          pais: 30,
          comprobante_tipo: 3,
          divisa: 'EUR'
        },
        {
          pais: 3,
          comprobante_tipo: 4,
          divisa: 'ARS'
        }
      ],
      paises: [],

      personas: [
        {
          id: 0,
          nombre: 'Persona Jurídica'
        },

        {
          id: 1,
          nombre: 'Persona Física'
        }
      ],

      provincias: [],
      showLoadingState: 0
    }
  },

  validations: {
    datos: {
      persona: {
        codigo_postal: {
          maxLength: maxLength(10),
          minLength: minLength(1),
          required
        },

        documento_numero: {
          maxLength: maxLength(45),
          minLength: minLength(1),
          required
        },

        documento_tipo: {
          required
        },

        fisica: {
          required
        },

        linea1: {
          maxLength: maxLength(120),
          minLength: minLength(1),
          required
        },

        linea2: {
          maxLength: maxLength(120),
          minLength: minLength(1)
        },

        localidad: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        },

        movil: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        },

        pais: {
          required
        },

        provincia: {
          required
        },

        telefono: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        },

        razon_social: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        }
      },

      punto_venta: {
        comprobante_tipo: {
          required
        },

        divisa: {
          required
        },

        mensaje_pie: {
          maxLength: maxLength(255),
          minLength: minLength(1),
          required
        },

        nombre: {
          maxLength: maxLength(60),
          minLength: minLength(1),
          required
        },

        numero: {
          minLength: minLength(1),
          maxLength: maxLength(10),
          required
        }
      }
    }
  },

  computed: {
    messageErrorCodigoPostal () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.codigo_postal, 'persona', 'codigo_postal')
    },

    messageErrorComprobanteTipo () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.punto_venta.comprobante_tipo, 'punto_venta', 'comprobante_tipo')
    },

    messageErrorDivisa () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.punto_venta.divisa, 'punto_venta', 'divisa')
    },

    messageErrorDocumentoNumero () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.documento_numero, 'persona', 'documento_numero')
    },

    messageErrorDocumentoTipo () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.documento_tipo, 'persona', 'documento_tipo')
    },

    messageErrorFisica () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.fisica, 'persona', 'fisica')
    },

    messageErrorLinea1 () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.linea1, 'persona', 'linea1')
    },

    messageErrorLinea2 () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.linea2, 'persona', 'linea2')
    },

    messageErrorLocalidad () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.localidad, 'persona', 'localidad')
    },

    messageErrorMensajePie () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.punto_venta.mensaje_pie, 'punto_venta', 'mensaje_pie')
    },

    messageErrorMovil () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.movil, 'persona', 'movil')
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.punto_venta.nombre, 'punto_venta', 'nombre')
    },

    messageErrorNumero () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.punto_venta.numero, 'punto_venta', 'numero')
    },

    messageErrorPais () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.pais, 'persona', 'pais')
    },

    messageErrorProvincia () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.provincia, 'persona', 'provincia')
    },

    messageErrorRazonSocial () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.razon_social, 'persona', 'razon_social')
    },

    messageErrorTelefono () {
      return this.$validation.getValidationMessage('mEditionBillingSalesDataCreateData', this.$v.datos.persona.telefono, 'persona', 'telefono')
    }
  },

  watch: {
    'datos.persona.pais' () {
      this.configurarMonedaDefecto()
    },

    'datos.punto_venta.comprobante_tipo' () {
      this.configurarMonedaDefecto()
      if (!this.datos.punto_venta.divisa_vende.length && this.datos.punto_venta.comprobante_tipo !== 1) {
        this.datos.punto_venta.divisa_vende.push(this.divisas.find(div => div.iso_code === this.datos.punto_venta.divisa).iso_code)
      }
    }
  },

  created () {
    this.datos.academia = this.$store.getters.getAcademyData.id
    this.readDivisas()
    this.readParametroPaises()
  },

  methods: {
    configurarMonedaDefecto () {
      const divisa = this.monedaDefecto.find(m =>
        m.pais === this.datos.persona.pais && m.comprobante_tipo === this.datos.punto_venta.comprobante_tipo
      )

      if (divisa) {
        this.datos.punto_venta.divisa = divisa.divisa
        this.isDivisaDisabled = true
      } else {
        this.isDivisaDisabled = false
      }
    },

    changeLogoImage (logoImg) {
      this.datos.punto_venta.imagen = logoImg
    },

    createPuntoVenta () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.configurarMonedaDefecto()
        this.$services.create('puntoVenta', 'createPuntoVenta', this.datos)
          .then(response => {
            this.$alerts.pushAlert('mEditionBillingSalesDataCreateData', 'createPuntoVenta', 'success')
            this.buttonPrimary.sending = false
            this.$license.readAcademiaRecursosUsados()
            this.$license.readAcademiaConfiguracionGlobal()
            this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.salesData.subject')}`)
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            if (error.response.data.error.message === 'Límite de puntos de ventas superado') {
              this.$modal.showModal('MoleculeLicenseModalUpgrade', 'puntosVenta')
            } else {
              this.$alerts.pushAlert('mEditionBillingSalesDataCreateData', 'createPuntoVenta', 'error', 'a-alert-danger')
            }
            this.buttonPrimary.sending = false
          })
      }
    },

    deleteLogoImage () {
      this.datos.punto_venta.imagen = ''
    },

    readComprobanteTipos () {
      if (this.datos.persona.pais !== '') {
        this.$services.read('comprobante', 'readComprobanteTipos', {}, [this.datos.persona.pais])
          .then(response => {
            let comprobantes = response.data

            // factura Arg solo vidroop
            if (this.datos.persona.pais === 3 && this.datos.academia !== config.vidroopAcademyId) {
              comprobantes = comprobantes.filter(
                comprobante => comprobante.id_comprobante_tipo !== 4
              )
            }
            this.comprobanteTipos = comprobantes
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    readParametroDocumentoTipos () {
      if (this.datos.persona.pais !== '') {
        this.$services.read('parametro', 'readParametroDocumentoTipos', {}, [this.datos.persona.pais])
          .then(response => {
            this.documentoTipos = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroProvincias () {
      if (this.datos.persona.pais !== '') {
        this.$services.read('parametro', 'readParametroProvincias', {}, [this.datos.persona.pais])
          .then(response => {
            this.provincias = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
}
</script>
